<template>
    <div>
        <el-collapse v-model="activeNames" @change="handleChange">
            <el-collapse-item v-for="(item, index) in businessUnitUsersPermissions" :key="index" :title="item.user.fullName" :name="index">
                <div class="permission-row">
                    <el-select v-model="item.activePressetId" placeholder="Select Presset" size="mini">
                        <el-option disabled label="Fixed Permissions" value="1"></el-option>

                        <el-option
                                v-for="presset in pressetsList"
                                v-show="presset.isDefault"
                                :key="presset.id"
                                :label="$t(presset.permissionPressetName)"
                                :value="presset.id"
                                @click.native="onSelectionChanged(presset, item)">
                        </el-option>

                        <el-option disabled label="Created Permissions" value="2"></el-option>

                        <el-option
                                v-for="presset in pressetsList"
                                v-show="!presset.isDefault"
                                :key="presset.id + 1000"
                                :label="$t(presset.permissionPressetName)"
                                :value="presset.id"
                                @click.native="onSelectionChanged(presset, item)">
                        </el-option>
                    </el-select>
                </div>
                <div class="permission-row">
                    <el-checkbox-group v-model="item.permissionsIdArr">
                        <div v-for="(permissions, index) in permissionsList" :key="index" class="permissions">
                            <div class="permissions__title">{{$t(permissions.permissionFilterName)}}:</div>
                            <el-checkbox v-for="(permission, index) in permissions.permissionList" :label="permission.id" :key="index" @change="changePermission(item)">{{$t(permission.permissionName)}}</el-checkbox>
                        </div>
                    </el-checkbox-group>
                </div>
                <div class="permission-row">
                    <el-button type="primary" plain size="mini" @click="saveUserPermissions(item)">Save</el-button>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "BusinessUnitPermissionTab",
        props: {
            permissionsList: {
                type: Array,
                default: () => []
            },
            pressetsList: {
                type: Array,
                default: () => []
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            },
            businessUnitUsersPermissions() {
                this.$store.getters.getBusinessUnitPermissionsList.forEach(val => {
                    val.activePressetId = val.permissionPreset ? val.permissionPreset.id : 0
                });
                return this.$store.getters.getBusinessUnitPermissionsList
            },
        },
        mounted(){

        },
        data() {
            return {
                activeNames: [],
                activePressetId: null
            }
        },
        methods: {
            onSelectionChanged(presset, item) {
                item.permissionsIdArr = presset.permissionPressetIdArr
            },
            saveUserPermissions(item){
                const data = {
                    userId: item.user.id,
                    companyId: item.companyId,
                    pressetId: item.activePressetId,
                    businessUnitId: item.businessUnitId,
                    permissions: item.permissionsIdArr
                };
                let loader = this.$loading.show();
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios
                    .post(`/api/v1/businessUnits/user/assignPermissions`, data)
                    .then(async response => {
                        try {
                            console.log('response', response);
                            this.notification("Success", "User permission successfully updated", "success");
                            loader.hide();
                            if (this.user.user.id === item.user.id) {
                                const permissions = await this.getBusinessUnitLayout(data.companyId, data.businessUnitId);

                                this.$emit('setNewPermissions', permissions)
                            }
                            this.activeNames = []
                        } catch(err){
                            console.log(err)
                        }
                    }).catch(error =>{
                    loader.hide();
                    console.log(error);
                })
            },
            getBusinessUnitLayout(companyId, businessUnitId){
                return new Promise ((resolve, reject) =>{
                    let loader = this.$loading.show();
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                    axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                    axios
                        .post(`/api/v1/businessUnitLayout/getData?companyId=${companyId}&businessUnitId=${businessUnitId}`)
                        .then(response => {
                            resolve(response.data.permission)
                            loader.hide()
                        })
                        .catch(error => {
                            console.log('An error occurred:', error);
                            loader.hide()
                        });
                })
            },
            changePermission(item){
                item.activePressetId = 0
            },
            handleChange(val) {
                console.log(val);
            },
            notification(title, message, type) {
                this.$notify({
                    title: title,
                    message: message,
                    type: type
                });
            },
        }
    }
</script>

<style scoped lang="less">
    .permissions {
        margin-bottom: 20px;
        &__title {
            font-size: 20px;
            margin-bottom: 5px;
            color: #B11A21;
        }
    }
    .permission-row{
        padding:10px;
    }

    /deep/.el-checkbox {
      margin-top: 10px;
      width: 200px;
      margin-right: 15px;
      white-space: normal !important;
      display: inline-flex;
      align-items: center;
      min-width: 200px;
    }
</style>
